import VerofreshRecord from './VerofreshRecord'
import { includes, union } from 'lodash'

class AuditLogRecord extends VerofreshRecord {
  getChangedAttributes () {
    let originalAttributes = []
    let newAttributes = []

    if (this.old) {
      originalAttributes = Object.keys(this.old)
    }

    if (this.new) {
      newAttributes = Object.keys(this.new)
    }

    const mergedAttributes = union(originalAttributes, newAttributes)

    const changedAttributes = []

    for (const attribute of mergedAttributes) {
      let originalValue
      let newValue

      if (includes(originalAttributes, attribute)) {
        originalValue = this.old[attribute]
      }

      if (includes(newAttributes, attribute)) {
        newValue = this.new[attribute]
      }

      changedAttributes.push({
        attribute: attribute,
        originalValue: originalValue,
        newValue: newValue
      })
    }

    return changedAttributes
  };
}

export default AuditLogRecord
